import { useTranslation } from 'react-i18next';

export default function GolfoDescription() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div>
            <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">{t('desc_about_golfo')}</p>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-6">{t('desc_title_golfo')}</h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>{t('desc_golfo_p1')}</p>
              <p>{t('desc_golfo_p2')}</p>
              <p>{t('desc_golfo_p3')}</p>
              <p>{t('desc_golfo_p4')}</p>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/4daac3bc-44fd-491a-a2d9-76a030df4bb3_compressed_Captura-de-pantalla-2026-07-16-a-las-14.12.16.webp"
                alt="Casa de El Golfo - Real living room with traditional Canarian wooden furniture and green doors"
                title="Casa de El Golfo Living Room - Authentic Canarian Interior"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-lg px-4 py-3">
              <span className="text-xs text-foreground-500">{t('license')}</span>
              <p className="text-sm font-semibold text-foreground-950 whitespace-nowrap">V-35-3-0000789</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}